import React, { useContext, useState } from 'react'
import './SideNave.scss'
import { VscListOrdered } from "react-icons/vsc";
import { TbCategory2 } from "react-icons/tb";
import { MdProductionQuantityLimits } from "react-icons/md";
import { GrBundle } from "react-icons/gr";
import { RiCoupon3Line } from "react-icons/ri";
import { TbBrandBlogger } from "react-icons/tb";
import { TbUserEdit } from "react-icons/tb";
import { IoMdAdd } from "react-icons/io";
import { RiDeleteBin2Line } from "react-icons/ri";
import { RxUpdate } from "react-icons/rx";
import { RiCloseCircleLine } from "react-icons/ri";
import { RiLogoutBoxLine } from "react-icons/ri";
import { FaBars } from "react-icons/fa";
import logo from '../../../Assets/imges/Logo.png'
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { MdForwardToInbox } from "react-icons/md";
import { IoCopyOutline } from "react-icons/io5";
import { MdOutlineInventory2 } from "react-icons/md";

import { useCookies } from 'react-cookie';
import { LocationContext } from '../../../Context/UserLocation';

export default function SideNave() {
    const { setRole, } = useContext(LocationContext);
    const [collapsed, setcollapsed] = useState(false)
    const [Hide, setHide] = useState(false);
    const { pathname } = useLocation();
    const navigate = useNavigate()
    const [, , removeCookie] = useCookies(['token']);
    const LogOut = () => {
        removeCookie(['token']);
        setRole(null);
        navigate('/')
    }


    const handleHide = () => {
        setHide(!Hide)
    }
    const handleICon = () => {
        setcollapsed(!collapsed)
    }
    return <>
        <div className={Hide ? "dropback apper-dropback" : "dropback "} onClick={handleHide}>
        </div>
        <aside className={Hide ? 'allnav ' : 'allnav apper'} >
            <Sidebar collapsed={collapsed}>

                <menu>
                    <Menu className={collapsed ? 'collapsed main-side overflow-y-auto min-h-screen' :
                        'main-side p-1 overflow-y-auto min-h-screen'}>

                        <MenuItem
                            className="mb-10 rounded-3xl text-3xl mt-8 text-[#bc7171] cursor-pointer"
                            onClick={handleICon}
                            icon={collapsed ? <FaBars /> : <RiCloseCircleLine />}
                            component={<span className='Remove_hover'></span>}
                        ></MenuItem>
                        <Link to={"/"}>
                            <span className='flex justify-center items-center my-9'>
                                <img src={logo} loading='lazy' alt="Logo" className={collapsed ? 'Logo-colaps' : 'Logo'} />
                            </span>
                        </Link>

                        <div className="flex justify-between flex-col">
                            <div className="Links">
                                <MenuItem onClick={handleHide} className={pathname === "/DashboardMema/Lowstock" ? 'menu-items  Active' : 'menu-items'}
                                    component={<Link to='/DashboardMema/Lowstock'
                                        className='Remove_hover transition ease-linear flex justify-center'></Link>}
                                    icon={<MdOutlineInventory2 />}>
                                    Inventory
                                </MenuItem>

                                <SubMenu className='SuMenu' label="Orders" icon={<VscListOrdered />}>
                                    <MenuItem onClick={handleHide} className={pathname === "/DashboardMema" ? 'menu-items  Active' : 'menu-items'}
                                        component={<Link to='/DashboardMema'
                                            className='Remove_hover transition ease-linear flex justify-center'></Link>}
                                        icon={<VscListOrdered />}>All orders </MenuItem>

                                    <MenuItem onClick={handleHide} className={pathname === "/DashboardMema/GuestOrders" ? 'menu-items  Active' : 'menu-items'}
                                        component={<Link to='GuestOrders'
                                            className='Remove_hover transition ease-linear flex justify-center'></Link>}
                                        icon={<VscListOrdered className={pathname === "/" ? 'icon transition ease-linear Active' :
                                            'icon transition ease-linear'} />}>All Guest orders </MenuItem>
                                </SubMenu>

                                <SubMenu label="Categories" className='SuMenu' icon={<TbCategory2 />}>
                                    <MenuItem onClick={handleHide} className={pathname === "/DashboardMema/AddCategoery" ? 'menu-items  Active' : 'menu-items'} component={<Link to='AddCategoery' className='Remove_hover transition ease-linear flex justify-center'></Link>}
                                        icon={<IoMdAdd className={pathname === "AddCategoery" ? 'icon transition ease-linear Active' : 'icon transition ease-linear'} />}>
                                        Add category </MenuItem>

                                    <MenuItem onClick={handleHide} className={pathname === `/DashboardMema/AllCategories` ? 'menu-items Active' : "menu-items"}
                                        component={<Link to={`AllCategories`} className='Remove_hover transition ease-linear'></Link>}
                                        icon={<VscListOrdered className={pathname === `AllCategories` ? 'icon transition ease-linear Active' :
                                            'icon transition ease-linear'} />}>
                                        All Categories
                                    </MenuItem>

                                    <MenuItem onClick={handleHide} className={pathname === `/DashboardMema/UpdateCategories` ? 'menu-items Active' : "menu-items"}
                                        component={<Link to={`UpdateCategories`} className='Remove_hover transition ease-linear'></Link>}
                                        icon={<RxUpdate className={pathname === `UpdateCategories` ? 'icon transition ease-linear Active' :
                                            'icon transition ease-linear'} />}>
                                        Update Categoery
                                    </MenuItem>
                                </SubMenu>

                                <SubMenu label="Products" className='SuMenu' icon={<MdProductionQuantityLimits />}>
                                    <MenuItem onClick={handleHide} className={pathname === "/DashboardMema/ProductsAdmin" ? 'menu-items  Active' : 'menu-items'}
                                        component={<Link to='ProductsAdmin' className='Remove_hover transition ease-linear flex justify-center'></Link>}
                                        icon={<IoCopyOutline className={pathname === "ProductsAdmin" ? 'icon transition ease-linear Active' : 'icon transition ease-linear'} />}>
                                        All products
                                    </MenuItem>

                                    <MenuItem onClick={handleHide} className={pathname === `/DashboardMema/CreateProduct` ? 'menu-items Active' : "menu-items"}
                                        component={<Link to={`CreateProduct`} className='Remove_hover transition ease-linear'></Link>}
                                        icon={<IoMdAdd className={pathname === `CreateProduct` ? 'icon transition ease-linear Active' : 'icon transition ease-linear'} />}>
                                        Add product
                                    </MenuItem>
                                    <MenuItem onClick={handleHide} className={pathname === `/DashboardMema/Reviews` ? 'menu-items Active' : "menu-items"}
                                        component={<Link to={`Reviews`} className='Remove_hover transition ease-linear'></Link>}
                                        icon={<RiDeleteBin2Line className={pathname === `Reviews` ? 'icon transition ease-linear Active' : 'icon transition ease-linear'} />}>
                                        Delete reviews
                                    </MenuItem>


                                </SubMenu>

                                <SubMenu label="Bundels" className='SuMenu' icon={<GrBundle />}>
                                    <MenuItem onClick={handleHide} className={pathname === "/DashboardMema/ABundles" ? 'menu-items  Active' : 'menu-items'} component={<Link to='ABundles' className='Remove_hover transition ease-linear flex justify-center'></Link>}
                                        icon={<IoMdAdd className={pathname === "/" ? 'icon transition ease-linear Active' : 'icon transition ease-linear'} />}>
                                        Add Bundel
                                    </MenuItem>

                                    <MenuItem onClick={handleHide} className={pathname === `/DashboardMema/deleteBundles` ? 'menu-items Active' : "menu-items"}
                                        component={<Link to={`deleteBundles`} className='Remove_hover transition ease-linear'></Link>}
                                        icon={<VscListOrdered className={pathname === `/` ? 'icon transition ease-linear Active' : 'icon transition ease-linear'} />}>
                                        All Bundels
                                    </MenuItem>

                                </SubMenu>

                                <SubMenu label="Coupons" className='SuMenu' icon={<RiCoupon3Line />}>
                                    <MenuItem onClick={handleHide} className={pathname === "/DashboardMema/AddCoupon" ? 'menu-items  Active' : 'menu-items'} component={<Link to='AddCoupon' className='Remove_hover transition ease-linear flex justify-center'></Link>}
                                        icon={<IoMdAdd className={pathname === "/" ? 'icon transition ease-linear Active' : 'icon transition ease-linear'} />}>
                                        Add coupon
                                    </MenuItem>

                                    <MenuItem onClick={handleHide} className={pathname === `/DashboardMema/AllCoupons` ? 'menu-items Active' : "menu-items"}
                                        component={<Link to={`AllCoupons`} className='Remove_hover transition ease-linear'></Link>}
                                        icon={<IoCopyOutline className={pathname === `/AllCoupons` ? 'icon transition ease-linear Active' : 'icon transition ease-linear'} />}>
                                        Get All Coupons
                                    </MenuItem>
                                </SubMenu>

                                <SubMenu label="BlogCreate" className='SuMenu' icon={<TbBrandBlogger />}>
                                    <MenuItem onClick={handleHide} className={pathname === "/DashboardMema/BlogCreate" ? 'menu-items  Active' : 'menu-items'} component={<Link to='BlogCreate' className='Remove_hover transition ease-linear flex justify-center'></Link>}
                                        icon={<IoMdAdd className={pathname === "BlogCreate" ? 'icon transition ease-linear Active' : 'icon transition ease-linear'} />}>
                                        Add Blog
                                    </MenuItem>

                                    <MenuItem onClick={handleHide} className={pathname === `/DashboardMema/DeleteBlogs` ? 'menu-items Active' : "menu-items"}
                                        component={<Link to={`DeleteBlogs`} className='Remove_hover transition ease-linear'></Link>}
                                        icon={<RiDeleteBin2Line className={pathname === `DeleteBlogs` ?
                                            'icon transition ease-linear Active' : 'icon transition ease-linear'} />}>
                                        Delete Blog
                                    </MenuItem>

                                    <MenuItem onClick={handleHide} className={pathname === `/DashboardMema/BlogUpdate` ? 'menu-items Active' : "menu-items"}
                                        component={<Link to={`BlogUpdate`} className='Remove_hover transition ease-linear'></Link>}
                                        icon={<RxUpdate className={pathname === `BlogUpdate` ? 'icon transition ease-linear Active' : 'icon transition ease-linear'} />}>
                                        Update Blog
                                    </MenuItem>

                                </SubMenu>

                                <SubMenu label="Users data" className='SuMenu' icon={<TbUserEdit />}>

                                    <MenuItem onClick={handleHide} className={pathname === `/DashboardMema/AUsersAdmin` ? 'menu-items Active' : "menu-items"}
                                        component={<Link to={`AUsersAdmin`} className='Remove_hover transition ease-linear'></Link>}
                                        icon={<VscListOrdered className={pathname === `/` ? 'icon transition ease-linear Active' : 'icon transition ease-linear'} />}>
                                        All Users Data
                                    </MenuItem>

                                    <MenuItem onClick={handleHide} className={pathname === `/DashboardMema/AUsersemails` ? 'menu-items Active' : "menu-items"}
                                        component={<Link to={`AUsersemails`} className='Remove_hover transition ease-linear'></Link>}
                                        icon={<MdForwardToInbox className={pathname === `AUsersemails` ? 'icon transition ease-linear Active' : 'icon transition ease-linear'} />}>
                                        Users Messages
                                    </MenuItem>
                                </SubMenu>

                            </div>

                        </div>

                        <MenuItem
                            className="rounded-3xl
                            font-semibold Logout"
                            icon={<RiLogoutBoxLine />}
                            type={"button"}
                            component={<span className='Remove_hover transition ease-linear'></span>}
                            onClick={LogOut}
                        >
                            Log out
                        </MenuItem>


                    </Menu>
                </menu>
            </Sidebar >
        </aside >

        <span className='bars' onClick={handleHide}>
            {Hide ? <RiCloseCircleLine /> : <FaBars />}
        </span>

    </>
}
